import axios from "axios";
import params from "../configs/params";
import store from "../store";
import { setAuthTokens } from "../features/auth/authSlice";

// Shared only within AI Assistant: streaming fetch and settings Axios must not
// independently rotate the same refresh token during simultaneous 401s.
let refreshPromise;
export function refreshAIAssistantAccessToken() {
  const refresh = localStorage.getItem("refreshToken");
  if (!refresh) return Promise.reject(new Error("Please sign in again."));
  if (!refreshPromise) {
    refreshPromise = axios.post(`${params.apiUrl}auth/token/refresh/`, { refresh }).then(({ data }) => {
      if (!data.access) throw new Error("Could not refresh authentication.");
      localStorage.setItem("accessToken", data.access);
      if (data.refresh) localStorage.setItem("refreshToken", data.refresh);
      if (data.access_token_expiration) localStorage.setItem("access_token_expiration", data.access_token_expiration);
      if (data.refresh_token_expiration) localStorage.setItem("refresh_token_expiration", data.refresh_token_expiration);
      store.dispatch(setAuthTokens({
        accessToken: data.access,
        refreshToken: data.refresh || refresh,
        accessTokenExpiration: data.access_token_expiration || localStorage.getItem("access_token_expiration"),
        refreshTokenExpiration: data.refresh_token_expiration || localStorage.getItem("refresh_token_expiration"),
      }));
      return data.access;
    }).finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}
